import { Component, OnInit } from '@angular/core';
import { Currency } from '../currency';
import { ActivatedRoute } from '@angular/router';
import { CurrencyService } from '../currency.service';
import { Message } from 'primeng/primeng';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { GlobalDataService } from '../../../../services/global-data.service';


import {Validators,FormControl,FormGroup,FormBuilder} from '@angular/forms';

 
@Component({
  selector: 'app-currency-crud',
  templateUrl: './currency-crud.component.html',
  styleUrls: ['./currency-crud.component.css'],
  providers: [CurrencyService]

})
export class CurrencyCrudComponent implements OnInit {

	id: any= null;
  currencyForm: FormGroup;
	currencies: Currency;
	msgs: Message[] = [];
 	button_caption: string ="Сохранить"
 	button_icon:string ="fa fa-save";
  loading: boolean = false;

  			
  constructor(
    private currencyService: CurrencyService,
    private activatedRoute: ActivatedRoute,
    private global: GlobalDataService,
    private fb: FormBuilder,
    private router: Router,
    private location: Location) {	

   		  activatedRoute.params.subscribe(params=>{this.id=params['id']});

        this.currencyForm = this.fb.group({
            'name': new FormControl('', Validators.required),
            'code': new FormControl('', Validators.required),
            'is_primary': new FormControl('', Validators.required),
            'short_name': new FormControl('',Validators.required),
            'symbol_left': new FormControl(),
            'symbol_right': new FormControl(),
            'available': new FormControl('', Validators.required)
        }); 

   		  if(this.id){
          this.loading=true;   
   		  	this.currencyService.getCurrencyById(this.id).subscribe(response=>{this.currencies=response['data']; this.loading=false;});	
   		 		this.button_caption="Редактировать";
   		 		this.button_icon="fa fa-edit";
   		  }

      }

  ngOnInit() {
  	 	this.currencies={
  		    id: "",
		      name: "",
			    code: "",
			    is_primary: false,
			    short_name: "",
		    	// symbol_left: "",
		    	// symbol_right: "",  
		    	available: false
  	    };
  }

  backClicked() {
        this.location.back();
  }

  ngOnDestroy(){
      
  }

  crud(form):void{
   		  if(!this.id){
            this.loading=true;   
   		  		this.currencyService.createCurrency(form.value)
   		  		.subscribe((data) => {this.loading=false;this.router.navigate(['/dashboard/currency']);}
                  , (error)=>{
                          this.loading=false; 
                  });
   		  }else{
          this.loading=true;   
   		  	this.currencyService.updateCurrency(form.value,this.id)
   		  		.subscribe((data) => {this.loading=false; this.router.navigate(['/dashboard/currency']);}
                  , (error)=>{
                          this.loading=false; 
                  });
   		  }



  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/currencies/currency-crud/currency-crud.component.ts